import {Checkbox} from '@/components/common-components/v2';
import {useStore} from '@/store/root-store';
import {opaqueColor} from '@/utils/colors';
import {faCopy} from '@fortawesome/pro-regular-svg-icons';
import {faCheck, faPlus} from '@fortawesome/pro-solid-svg-icons';
import {faSquareCheck} from '@fortawesome/pro-light-svg-icons';
import {faXmark} from '@fortawesome/pro-light-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Tooltip} from 'antd';
import {EditorState, Modifier, SelectionState, ContentState} from 'draft-js';
import {debounce} from 'lodash';
import {observer} from 'mobx-react';
import {useCallback, useState} from 'react';
import styled from 'styled-components';
// import {convertHtmlToEditorState} from '@/utils/htmlToDraft';

interface Props {
  activeCompetitor: any;
  htmlToDraft: any;
  setShowBulkAddContentBtn?: (value: boolean) => void;
  showBulkAddContentBtn?: boolean;
  setCheckedCount?: (value: number) => void;
  checkedCount?: number;
  setCheckedHeadingsWithTags?: (value: string) => void;
  checkedHeadingsWithTags?: string;
  setCheckedIndexData?: (value: any) => void;
  checkedIndexData?: any;
}

export const HeadingsTree = observer(({
  activeCompetitor,
  htmlToDraft,
  setShowBulkAddContentBtn,
  showBulkAddContentBtn,
  setCheckedCount,
  checkedCount,
  setCheckedIndexData,
  checkedIndexData}: Props) => {
  const {contentOptimizer: {currentPage}} = useStore('');
  const {contentOptimizer:
    {currentPage: {
      setCopiedHeadings,
    }}} = useStore('');


  const [addedHeadings, setAddedHeadings] = useState([]);
  const [copiedHeading, setCopiedHeading] = useState({
    tag: '',
    text: '',
  });

  const [filters, setFilters] = useState([
    {
      tag: 'h1',
      active: true,
    },
    {
      tag: 'h2',
      active: true,
    },
    {
      tag: 'h3',
      active: true,
    },
    {
      tag: 'h4',
      active: true,
    },
    {
      tag: 'h5',
      active: true,
    },
    {
      tag: 'h6',
      active: true,
    },
  ]);

  const onCheckboxChecked = (checked: boolean, tag: string) => {
    const curFilters = [...filters];

    const updatedFilters = curFilters.map(filter => {
      if (filter.tag == tag) {
        return {
          ...filter,
          active: checked,
        };
      } else {
        return {...filter};
      }
    });

    setFilters(updatedFilters);
  };

  const checkboxClickHandler = (e, headingContent, headingTag, idx) => {
    if (e?.target?.checked) {
      setCheckedCount(checkedCount + 1);
      const newItem = {'id': idx, 'headingContent': headingContent, 'headingTag': headingTag};
      setCheckedIndexData([...checkedIndexData, newItem]);
    } else {
      setCheckedCount(checkedCount - 1);

      const updatedCheckedIndexData = checkedIndexData.filter(item => item?.id !== idx);
      setCheckedIndexData(updatedCheckedIndexData);
    }
  };

  const handleCopyClick = () => {
    setCopiedHeadings('');
    let updatedCopiedHeadings = '';
    checkedIndexData?.map(item => {
      updatedCopiedHeadings += `<${item?.headingTag}>${item?.headingContent}</${item?.headingTag}>`;
    });
    setCopiedHeadings(updatedCopiedHeadings);
    navigator.clipboard.writeText(updatedCopiedHeadings);
  };

  // const [blockskMap, setBlocksMap] = useState([]);

  // const mapHeadingsToDraftBlockTypes = {
  //   'h1': 'header-one',
  //   'h2': 'header-twp',
  //   'h3': 'header-three',
  //   'h4': 'header-four',
  //   'h5': 'header-five',
  //   'h6': 'header-six',
  // }

  // useEffect(() => {
  //   if (!currentPage?.getCurrentEditorState) return;

  //   const contentState = currentPage.getCurrentEditorState.getCurrentContent();

  //   const map = convertToRaw(contentState).blocks
  //   setBlocksMap(map);

  // }, [currentPage?.getCurrentEditorState]);


  // const checkIfEditorContainsHeading = (text: string, type: string) => {
  //   if (!blockskMap || !blockskMap.length) return false;

  //   const included = blockskMap.find(block => block.type == mapHeadingsToDraftBlockTypes[type] && block.text == text);

  //   return included;
  // }

  const debouncedChange = debounce((state: EditorState, focusTerms, focusTermsClassNames, isNewDecorations = false) => {
    // we are then calling the edit content method which will fire the API call and send new state to the BE
    currentPage.editContent(state, isNewDecorations);
  }, 2000);


  const debouncedUpdate = useCallback(
    (state: EditorState, focusTerms, focusTermsClassNames, isNewDecorations) => debouncedChange(state, focusTerms, focusTermsClassNames, isNewDecorations),
    // eslint-disable-next-line
        []
  );

  const insertText = async (textToAdd: any, headingType?: string, cleanText?: string) => {
    // NEW FLOW start
    const {contentBlocks, entityMap} = htmlToDraft(textToAdd);
    // const contentState = convertHtmlToEditorState(textToAdd);

    const selection = currentPage.currentEditorState.getSelection();

    const newSelection = new SelectionState({
      anchorKey: selection.getAnchorKey(),
      anchorOffset: selection.getEndOffset(),
      focusKey: selection.getAnchorKey(),
      focusOffset: selection.getEndOffset(),
    });


    const fragment = ContentState.createFromBlockArray(contentBlocks, entityMap).getBlockMap();
    // const fragment = contentState.getCurrentContent().getBlockMap();

    const nonStyledState = Modifier.replaceWithFragment(
      currentPage.currentEditorState.getCurrentContent(),
      newSelection,
      fragment,
    );

    // WE are calculating nodes to toggle blue background on new Ai generated nodes
    let firstNewBlockId: number;
    const currentBlock = selection.getAnchorKey();
    const nextBlock = currentPage.currentEditorState.getCurrentContent().getBlockAfter(selection.getAnchorKey())?.getKey();

    const existingNodes = document.querySelectorAll('[data-block="true"]');
    existingNodes?.forEach((elem, id) => {
      if (elem.getAttribute('data-offset-key') && elem.getAttribute('data-offset-key') == `${currentBlock}-0-0`) {
        firstNewBlockId = id + 1;
      }
    });


    const updatedState = EditorState.push(currentPage.currentEditorState, nonStyledState, 'insert-fragment');
    currentPage.setCurrentEditorState(updatedState);

    setTimeout(() => {
      const newTextElems = document.querySelectorAll('[data-block="true"]');
      if (newTextElems.length) {
        for (let i = firstNewBlockId; i <= newTextElems.length; i++) {
          if (newTextElems[i]?.getAttribute('data-offset-key') && newTextElems[i]?.getAttribute('data-offset-key') != `${nextBlock}-0-0` && newTextElems[i]?.getAttribute('data-offset-key') != `${currentBlock}-0-0`) {
            newTextElems[i].classList.add('newTextBlock');
          } else {
            return;
          }
        }
      }
    }, 500);

    debouncedUpdate(updatedState, currentPage.analytics?.focusTerms, currentPage.focusTermsClassNames, false);

    setTimeout(() => {
      const newTextElems = document.querySelectorAll('.newTextBlock');
      if (newTextElems.length) {
        newTextElems.forEach(elem => {
          elem.classList.remove('newTextBlock');
        });
      }
    }, 3500);

    const curAddedHeadings = [...addedHeadings];
    const updatedAddedHeading = [];
    checkedIndexData?.map(item => {
      updatedAddedHeading?.push({type: item?.headingTag, text: item?.headingContent});
    });
    if (headingType && cleanText) {
      setAddedHeadings([
        ...curAddedHeadings,
        {
          type: headingType,
          text: cleanText,
        },
      ]);
    } else {
      setAddedHeadings([
        ...curAddedHeadings,
        ...updatedAddedHeading,
        {
          type: headingType,
          text: cleanText,
        },
      ]);
    }
    // NEW FLOW END
  };

  const addHeadingsHandler = () => {
    setCopiedHeadings('');
    let updatedCopiedHeadings = '';
    checkedIndexData?.map(item => {
      updatedCopiedHeadings += `<${item?.headingTag}>${item?.headingContent}</${item?.headingTag}>`;
    });
    setCopiedHeadings(updatedCopiedHeadings);
    insertText(`<p></p>${updatedCopiedHeadings}`);
    setShowBulkAddContentBtn(true);
    setCheckedCount(0);
    setCheckedIndexData([]);
  };

  return <Wrapper>
    <div style={{color: '#4E5156'}}>Page structure</div>
    <FiltersWrapper>
      <FiltersContainer>
        {filters.map((filter, idx) => {
          if (activeCompetitor?.headingsHierarchy?.find(heading => heading.tag == filter.tag)) {
            return <CheckboxStyled
              tag={filter.tag as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' |'h6'}
              defaultChecked={filter.active}
              checked={filter.active}
              onChange={e => onCheckboxChecked(e.target.checked, filter.tag)}
              key={idx}>
              {filter.tag}
            </CheckboxStyled>;
          }
        })}
      </FiltersContainer>
      {showBulkAddContentBtn && <BulkAddAction onClick={() => setShowBulkAddContentBtn(false)}><FontAwesomeIcon icon={faSquareCheck}/>&nbsp;&nbsp;Bulk Add to Content</BulkAddAction>}
    </FiltersWrapper>
    {!showBulkAddContentBtn &&
      <ActionsWrapper>
        <AddHeadings onClick={() => {
          addHeadingsHandler();
        }}><FontAwesomeIcon icon={faPlus} fontSize='14px' color='#2D6CCA' />&nbsp;Add {checkedCount} headings to content</AddHeadings>
        <Tooltip title={<div style={{display: 'flex', alignItems: 'center'}}>
          Copy to clipboard
        </div>}><CopyAction onClick={() => {
            handleCopyClick();
          }}><FontAwesomeIcon icon={faCopy}/>&nbsp;Copy</CopyAction></Tooltip>
        <CancelAction onClick={() => {
          setCheckedCount(0);
          setShowBulkAddContentBtn(true);
          setCheckedIndexData([]);
          setCopiedHeadings('');
        }}><FontAwesomeIcon icon={faXmark}/>&nbsp;&nbsp;Cancel</CancelAction>
      </ActionsWrapper>
    }
    <FiltersTree>
      {activeCompetitor?.headingsHierarchy?.filter(heading => filters.filter(filter => filter.active)?.map(filter => filter.tag)?.includes(heading.tag))?.map((heading, idx) => {
        const isIncluded = [...addedHeadings].filter(item => item.text == heading.content && item.type == heading.tag)?.length > 0;
        return <SingleHeading
          isIncluded={isIncluded
            // checkIfEditorContainsHeading(heading.content, heading.tag)
          }
          key={idx} type={heading.tag} itemId={idx}>
          {!showBulkAddContentBtn && <Checkbox style={{marginRight: '10px'}} disabled={isIncluded} customBackground='#2D6CCA' onChange={e => checkboxClickHandler(e, heading.content, heading.tag, idx)} />
          }
          <HeadingTag type={heading.tag}>
            {isIncluded ? <FontAwesomeIcon icon={faCheck} style={{position: 'absolute', left: -17, top: 5, color: '#1FAC47'}}/>: null}
            {heading.tag}
          </HeadingTag>
          <HeadingText type={heading.tag}>{heading.content}</HeadingText>
          <div style={{display: 'flex', alignItems: 'center', marginLeft: 'auto'}}>
            <Tooltip title={<div style={{display: 'flex', alignItems: 'center'}}>
              {copiedHeading.tag == heading.tag && copiedHeading.text == heading.content ? <>
                <FontAwesomeIcon icon={faCheck} style={{marginRight: 5, color: '#1FAC47'}}/>
                Copied
              </> :
                'Copy to clipboard'
              }
            </div>}>
              <Copy className='copyClass' onClick={() => {
                navigator.clipboard.writeText(`<${heading.tag}>${heading.content}</${heading.tag}>`);
                setCopiedHeading({tag: heading.tag, text: heading.content});
              }}>
                <FontAwesomeIcon style={{marginRight: 5}} icon={faCopy} />
                Copy
              </Copy>
            </Tooltip>
            <InsertText className={`copyClass ${isIncluded ? 'disabled' : ''}`} onClick={() => insertText(`<p></p><${heading.tag}>${heading.content}</${heading.tag}>`, heading.tag, heading.content)}>
              <FontAwesomeIcon style={{marginRight: 5}} icon={faPlus} />
              Add to Content
            </InsertText>
          </div>

        </SingleHeading>;
      })}
    </FiltersTree>
  </Wrapper>;
});
const calculateIndent = (tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6') => {
  switch (tag) {
    case 'h1':
      return '15px';
    case 'h2':
      return '25px';
    case 'h3':
      return '45px';
    case 'h4':
      return '55px';
    case 'h5':
      return '65px';
    case 'h6':
      return '75px';
  }
};
const getTopMargin = (tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6') => {
  switch (tag) {
    case 'h1':
      return '20px';
    default:
      return '0px';
  }
};
const calculateFontSize = (tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6') => {
  switch (tag) {
    case 'h1':
      return '21px';
    case 'h2':
      return '18px';
    case 'h3':
      return '16px';
    case 'h4':
      return '14px';
    case 'h5':
      return '14px';
    case 'h6':
      return '14px';
  }
};
const generateColor = (tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6') => {
  switch (tag) {
    case 'h1':
      return '#233A61';
    case 'h2':
      return opaqueColor('#233A61', 85);
    case 'h3':
      return opaqueColor('#233A61', 70);
    case 'h4':
      return opaqueColor('#233A61', 55);
    case 'h5':
      return opaqueColor('#233A61', 47);
    case 'h6':
      return opaqueColor('#233A61', 40);
  }
};

const Wrapper = styled.div`

`;

const ActionsWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 10px;
`;

const AddHeadings = styled.div`
  font-size: 12px;
  color: #2D6CCA;
  cursor: pointer;
`;

const CopyAction = styled.div`
  font-size: 12px;
  cursor: pointer;
`;

const CancelAction = styled.div`
  cursor: pointer;
  color: #F44343;
`;

const FiltersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const BulkAddAction = styled.div`
  margin-top: 12px;
  color: #2D6CCA;
  cursor: pointer;
`;

const FiltersContainer = styled.div`
  display: flex;
  background: #F9F9FB;
  border: 1px solid #E8E8E8;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 20px;
  width: fit-content;
`;

const FiltersTree = styled.div`
  display: flex;
  flex-direction: column;
`;
const SingleHeading = styled.div<{type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'; itemId: number; isIncluded?: boolean}>`
  display: flex;
  margin-top: ${p => p.itemId == 0 ? '0px' : getTopMargin(p.type)};
  margin-bottom: 0px;
  border-radius: 8px;
  padding: 6px 10px;
  cursor: pointer;
  align-items: center;
  width: 100%;
  opacity: ${p => p.isIncluded ? .5 : 1};

  .copyClass {
    display: none;
    margin-left: auto;
  }
  .copyClass.disabled {
      pointer-events: none;
      color: gray;
    }

  &:hover {
    background-color: ${opaqueColor('#2D6CCA', 15)};

    .copyClass {
      display: block;
    }
  }
`;
const HeadingTag = styled.div<{type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'}>`
  border-radius: 5px;
  margin-left: ${p => calculateIndent(p.type)};
  background-color: ${p => generateColor(p.type)};
  padding: 2px 7px; 
  margin-right: 10px;
  color: #fff;
  height: fit-content;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
`;
const HeadingText = styled.div<{type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'}>`
  color: #121212;
  font-size: ${p => calculateFontSize(p.type)};
  ${p => (p.type == 'h1' || p.type == 'h2') && 'line-height: 24px'};
`;

const Copy = styled.div`
  display: flex;
  align-items: center;
  color: #000;
  font-size: 12px;
  font-weight: 500;
  margin-right: 20px;
  margin-bottom: auto;
  min-width: 50px;

  &:hover {
    color: #2D6CCA;
  }
`;
const InsertText = styled.div`
  display: flex;
  align-items: center;
  color: #000;
  font-size: 12px;
  font-weight: 500;
  margin-left: 20px;
  margin-bottom: auto;
  min-width: 105px;

  &:hover {
    color: #2D6CCA;
  }
`;

const CheckboxStyled = styled(Checkbox)<{tag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'}>`
text-transform: uppercase;
  .ant-checkbox-checked {
    .ant-checkbox-inner {
      background-color: ${p => generateColor(p.tag)} !important;
      border-color: ${p => generateColor(p.tag)} !important;
    }
  }
`;
